// ** Modules
import { useContext } from 'react';

// ** Context
import { SettingsContext } from '@/components/SettingContext';

// ** Types
import type { SettingsContextValue } from '@/types/contextTypes';

/**
 * Custom hook to access the SettingsContext
 */
export const useSettings = (): SettingsContextValue => {
	const context = useContext(SettingsContext);

	if (!context) {
		throw new Error('useSettings must be used within a SettingsProvider');
	}

	return context;
};
